import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=ede74c0e&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ede74c0e')) {
      api.createRecord('ede74c0e', component.options)
    } else {
      api.reload('ede74c0e', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=ede74c0e&", function () {
      api.rerender('ede74c0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Projects/PressureTestReport/Index.vue"
export default component.exports